
const EMAIL_API = "https://beta.chattrick.witniumtech.com/api/integrations/send-email"

// Add styles to ensure consistent button styling in modals
const styles = document.createElement('style');
styles.innerHTML = `
  .modal-submit-button {
    background-color: #1E88E5 !important;
    background: #1E88E5 !important;
    color: white !important;
  }
  
  /* Override ChatBubble button styles */
  .fixed.inset-0.bg-black.bg-opacity-60 button {
    all: unset;
    cursor: pointer;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .fixed.inset-0.bg-black.bg-opacity-60 .modal-submit-button {
    background-color: #1E88E5 !important;
    color: white !important;
    font-weight: normal;
    height: auto;
    width: auto;
    border-radius: 0.5rem;
    padding: 0.625rem 1.25rem;
  }
  
  .fixed.inset-0.bg-black.bg-opacity-60 .modal-cancel-button {
    background-color: white !important;
    color: #333 !important;
    border: 1px solid #ccc !important;
    border-radius: 0.5rem;
    padding: 0.625rem 1.25rem;
  }
`;
document.head.appendChild(styles);

/**
 * Sends an email using your server-side endpoint
 * @param {string} from - Sender email address
 * @param {string} to - Recipient email address 
 * @param {string} subject - Email subject
 * @param {string} body - Email body content (HTML)
 * @returns {Promise} Resolves when email is sent
 */
async function sendEmail(from, to, subject, body) {
    try {
        // Instead of calling SendGrid directly, call your own server endpoint
        const response = await fetch(EMAIL_API, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                from,
                to,
                subject,
                body
            })
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(`Failed to send email: ${response.status} ${errorData.message || ''}`);
        }
        
        return await response.json();

    } catch (error) {
        console.error('Error sending email:', error);
        throw error;
    }
}

export { sendEmail };
